import { render, staticRenderFns } from "./21-controls.vue?vue&type=template&id=5efb6088&scoped=true"
import script from "./21-controls.vue?vue&type=script&lang=ts"
export * from "./21-controls.vue?vue&type=script&lang=ts"
import style0 from "./21-controls.vue?vue&type=style&index=0&id=5efb6088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb6088",
  null
  
)

export default component.exports